<div class="personal-data-container component-container">
  <form
    #addressData="ngForm"
    class="form-section form-font-size"
    [appStringMatch]="['subEmail', 'subRepeatEmail']"
    (change)="formChanged()">
    <ng-container *ngIf="personData">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required">
            {{ 'personal-data.form-details.fields.title' | translate }}
          </label>
          <p-dropdown
            [options]="allTitles"
            placeholder="Please select"
            name="subTitle"
            [(ngModel)]="personData.sk_title"
            #subTitle="ngModel"
            required
            optionValue="value"
            (ngModelChange)="formChanged()"
            [disabled]="isDisabled">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">
                {{ 'lookup.' + titleKey + '.options.' + item['value'] + '.name' | translate }}
              </span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">
                  {{ 'lookup.' + titleKey + '.options.' + option['value'] + '.name' | translate }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align">{{ 'personal-data.form-details.fields.company' | translate }}</label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            maxlength="50"
            [(ngModel)]="personData.company_name"
            name="ppoCompany"
            #ppoCompany="ngModel"
            [disabled]="isDisabled" />
        </div>
      </div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="personal-data-fname">
            {{ 'personal-data.form-details.fields.first-name' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            maxlength="50"
            [(ngModel)]="personData.firstname"
            name="subFirstName"
            #subFirstName="ngModel"
            required
            [disabled]="isDisabled" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align required" for="personal-data-lname">
            {{ 'personal-data.form-details.fields.last-name' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            maxlength="50"
            [(ngModel)]="personData.lastname"
            name="subLastName"
            #subLastName="ngModel"
            required
            [disabled]="isDisabled" />
        </div>
      </div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="personal-data-street">
            {{ 'personal-data.form-details.fields.street' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            maxlength="30"
            [(ngModel)]="personData.street"
            name="subStreet"
            #subStreet="ngModel"
            required
            [disabled]="personData.is_address_assigned || isDisabled" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align required" for="personal-data-street-no">
            {{ 'personal-data.form-details.fields.street-number' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            maxlength="10"
            [(ngModel)]="personData.street_no"
            name="subStreetNo"
            #subStreetNo="ngModel"
            required
            [disabled]="personData.is_address_assigned || isDisabled" />
        </div>
      </div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" for="personal-data-address-suffix">
            {{ 'personal-data.form-details.fields.address-suffix' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            [(ngModel)]="personData.address_suffix"
            name="subAddressSuffix"
            #subAddressSuffix="ngModel"
            [disabled]="isDisabled" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align required" for="personal-data-land">
            {{ 'personal-data.form-details.fields.land' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            [(ngModel)]="personData.country"
            name="subLand"
            #subLand="ngModel"
            required
            [disabled]="isDisabled" />
        </div>
      </div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="personal-data-city">
            {{ 'personal-data.form-details.fields.city' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            maxlength="100"
            [(ngModel)]="personData.city"
            name="subCity"
            #subCity="ngModel"
            required
            [disabled]="personData.is_address_assigned || isDisabled" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align required" for="personal-data-postcode">
            {{ 'personal-data.form-details.fields.post-code' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            appAllowOnlyDigits
            maxDigits="5"
            minDigits="4"
            [(ngModel)]="personData.postcode"
            name="subPostcode"
            #subPostcode="ngModel"
            required
            [disabled]="personData.is_address_assigned || isDisabled" />
        </div>
      </div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required">
            {{ 'personal-data.form-details.fields.telephone' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            maxlength="50"
            [(ngModel)]="personData.phone"
            name="subPhone"
            #subPhone="ngModel"
            required
            [disabled]="isDisabled" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align">{{ 'personal-data.form-details.fields.mobile' | translate }}</label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            maxlength="50"
            [(ngModel)]="personData.mobile"
            name="subMobile"
            #subMobile="ngModel"
            [disabled]="isDisabled" />
        </div>
      </div>

      <div *ngIf="hasEmail" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required">{{ 'personal-data.form-details.fields.email' | translate }}</label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            maxlength="200"
            [(ngModel)]="personData.email"
            name="subEmail"
            #subEmail="ngModel"
            required
            appEmailValid
            [disabled]="isDisabled" />
        </div>
      </div>

      <div *ngIf="hasEmail && !isDetailsView && !appNotFinished" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required">
            {{ 'personal-data.form-details.fields.repeat-email' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            pInputText
            size="30"
            maxlength="200"
            [(ngModel)]="personData.repeat_email"
            name="subRepeatEmail"
            #subRepeatEmail="ngModel"
            required
            appEmailValid
            [disabled]="isDisabled" />
        </div>
      </div>
    </ng-container>
  </form>
</div>
